var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSigned = function SvgSigned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 21,
      height: 21
    },
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#E85B78",
    strokeWidth: 1.667,
    d: "m17.744 10.22.001.001c.34.338.34.811 0 1.15l-.002.001-6.667 6.668h-.001c-.339.341-.811.341-1.15 0h-.001l-6.668-6.668-.001-.001c-.34-.339-.34-.812 0-1.15l.001-.001 6.668-6.668.001-.001c.339-.34.811-.34 1.15 0l.001.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E85B78",
    strokeWidth: 1.667,
    d: "M10.5 6.629v5M10.5 13.296v1.667"
  })));
};
export default SvgSigned;